import React from 'react'
import { type ISendFromUiProps, SendFromUi } from 'widgets/SendFrom/ui/SendFromUi'
import { SendFromContext } from 'widgets/SendFrom/context/context'
import { type SendFromStore } from 'widgets/SendFrom'

type ISendFromProps = {
  store: SendFromStore
} & ISendFromUiProps

export const SendFrom = ({ store, ...props }: ISendFromProps) => {
  return (
    <SendFromContext.Provider value={store}>
      <SendFromUi {...props} />
    </SendFromContext.Provider>
  )
}
